import { render, staticRenderFns } from "./CaseAnalysisQuestionsReal.vue?vue&type=template&id=c465aeb8&scoped=true"
import script from "./CaseAnalysisQuestionsReal.vue?vue&type=script&lang=js"
export * from "./CaseAnalysisQuestionsReal.vue?vue&type=script&lang=js"
import style0 from "./CaseAnalysisQuestionsReal.vue?vue&type=style&index=0&id=c465aeb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c465aeb8",
  null
  
)

export default component.exports